import { InputAdornment } from '@mui/material';
import React from 'react';

import { CurrencyInputField } from '@occc-app/design-system';
import { parseNumber } from '@occc-app/lib/finalFormUtils';

interface IWalletCurrencyInputFieldProps {
  fieldArrayName: string;
  periodLabel?: string;
}

export const WalletCurrencyInputField = ({
  fieldArrayName,
  periodLabel,
}: IWalletCurrencyInputFieldProps) => (
  <CurrencyInputField
    name={`${fieldArrayName}.value`}
    label='Dollar amount'
    InputProps={{
      startAdornment: null,
      endAdornment: (
        <InputAdornment position='end'>{`$${periodLabel && ` ${periodLabel}`}`}</InputAdornment>
      ),
    }}
    InputLabelProps={{
      shrink: true,
    }}
    fieldProps={{
      parse: parseNumber,
    }}
  />
);
